export default "__VITE_ASSET__NIOpHjY5__"